import { Modal } from '@trackman/web-shared-components';
import { Button } from 'components/Button/Button';
import React from 'react';
import styled from 'styled-components';

const Separator = styled.hr`
  border-top: 1px solid #e0e0e0;
`;

const ControlsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 24px 24px;
`;

const Content = styled.div`
  padding: 24px 24px 8px;
  font-size: 13px;
`;

const StyledModal = styled((props) => <Modal {...props} />)`
  div[class*='-modalBody-'] {
    padding-right: 0;
    overflow-y: auto;
  }
`;

type MissingOwningOrgModalProps = {
  isOpen: boolean;
  openSettingsModal: () => void;
  onDismiss: () => void;
  submitWithoutOwningOrg: () => void;
};

export const MissingOwningOrgModal: React.FC<MissingOwningOrgModalProps> = (props) => {
  const { isOpen, openSettingsModal, onDismiss, submitWithoutOwningOrg } = props;
  return (
    <StyledModal title='Owning Organization Missing' open={isOpen} onClose={onDismiss} maxWidth='xs'>
      <Content>The delivery of this game’s data will be delayed if the owning organization is not set. </Content>
      <Separator />
      <ControlsWrapper>
        <Button intent='default' label='Submit without it' onClick={submitWithoutOwningOrg} fullWidth />
        <Button intent='primary' label='Set organization' onClick={openSettingsModal} fullWidth />
      </ControlsWrapper>
    </StyledModal>
  );
};
